import React from 'react';
import {Button, Label} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from "../../shared/language/Translate";
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from "../../shared/component/form/AvField";
import FormSection from "../../shared/component/form/FormSection";
import {toast} from "react-toastify";
import MerchantAccountService from "../../shared/service/MerchantAccountService";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import {DATA_UPLOAD_ENTITY} from "../../shared/utils/Constants";
import MerchantBranchDataService from "../../shared/service/MerchantBranchDataService";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import {Checkbox} from "primereact/checkbox";
import Loading from "../../shared/component/others/Loading";
import '../../shared/styles/SettingsPage.css';

const defaultUploadData = {
    merchantBranchId: null,
    uploadEntity: null,
    tax: false,
    department: false,
    productGroup: false,
    product: false,
    webMenu: false,
    mixAndMatch: false,
    floorPlanning: false,
    productTag: false,
    tag: false,
    supplier: false,
    tillCustomer: false,
    driver: false,
    transactions: false,
    definitions: false
};
export default class DataUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataUpload: Object.assign({}, defaultUploadData), dataSaveButtonRender: false,
            dataResetButtonRender: false,
            dataUploadTemp: Object.assign({}, defaultUploadData),
            merchantAccountList: [],
            merchantBranchList: [],
            entityList: DATA_UPLOAD_ENTITY

        }
        this.merchantAccountService = new MerchantAccountService();
        this.merchantBranchService = new MerchantBranchService();
        this.merchantBranchDataService = new MerchantBranchDataService();
    }

    componentDidMount() {

        this.merchantAccountService.findAll().then(response => this.setState({
            merchantAccountList: response
        }));
    }

    render() {
        return (
            <div className="settings-page settings-page--full settings-page--data-upload col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Data Upload</h1>
                        </div>
                        <div className="settings-page__panel">
                            <div className="settings-page__upload-sections">
                                {this.branchDetails()}
                                {this.dataDetails()}
                                {this.dataReset()}
                            </div>
                        </div>
                    </div>
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }

    branchDetails() {

        return (
            <FormSection title="Merchant Branch" className="settings-page__upload-section">

                <ModalConfirm header='Warning' ok='OK' onOkClick={this.saveData}
                              onCancelClick={() => this.setState({displayApproveConfirmDialog: false})}
                              show={this.state.displayApproveConfirmDialog}
                              message={this.state.noticeResponse}/>

                <ModalConfirm header='Warning' ok='OK' onOkClick={this.resetData}
                              onCancelClick={() => this.setState({displayResetConfirmDialog: false})}
                              show={this.state.displayResetConfirmDialog}
                              message={this.state.noticeResponse}/>

                <div className="settings-page__upload-branch-filters settings-page__form-fields">
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="data-upload-merchant-account">
                                <Translate contentKey="contactManagement.mobilePhone">Merchant Account</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="data-upload-merchant-account"
                                type="select"
                                disabled={!this.state.dataSaveButtonRender && !this.state.dataResetButtonRender}
                                className="form-control"
                                name="merchantAccountId"
                                value={this.state.merchantAccountId}
                                onChange={this.__handleChangeMerchantAccount}>
                                <option value='' key=''/>
                                {this.state.merchantAccountList.map(element => (
                                    <option value={element.id} key={element.id}>
                                        {element.tradingName}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>
                    <div className="settings-page__filter-field">
                        <AvGroup>
                            <Label for="data-upload-merchant-branch">
                                <Translate contentKey="contactManagement.mobilePhone">Merchant Branch</Translate>
                                <span style={{color: 'red'}}> (*)</span>
                            </Label>
                            <AvField
                                id="data-upload-merchant-branch"
                                type="select"
                                disabled={!this.state.dataSaveButtonRender && !this.state.dataResetButtonRender}
                                className="form-control"
                                name="merchantBranchId"
                                value={this.state.dataUpload.merchantBranchId}
                                onChange={this.__handleChange}>
                                <option value='' key=''/>
                                {this.state.merchantBranchList.map(element => (
                                    <option value={element.id} key={element.id}>
                                        {element.tradingName}
                                    </option>))}
                            </AvField>
                        </AvGroup>
                    </div>
                </div>

            </FormSection>
        );
    };

    renderUploadCheckbox(name, label) {
        return (
            <div className="settings-page__upload-check-item" key={name}>
                <Checkbox
                    onChange={(e) => this.setChecked(name, e.checked)}
                    name={name}
                    disabled={!this.state.dataSaveButtonRender}
                    value={this.state.dataUpload[name]}
                    checked={this.state.dataUpload[name]}/>
                <Label for={name}>
                    <Translate contentKey="Thursday">{label}</Translate>
                </Label>
            </div>
        );
    }

    dataDetails() {
        const checkboxes = [
            ['tax', 'Tax'],
            ['department', 'Department'],
            ['productGroup', 'Product Group'],
            ['product', 'Product'],
            ['webMenu', 'Web Menu'],
            ['mixAndMatch', 'Mix & Match'],
            ['floorPlanning', 'Floor Planning'],
            ['tag', 'Tag'],
            ['productTag', 'Product Tag'],
            ['supplier', 'Supplier'],
            ['driver', 'Driver'],
            ['tillCustomer', 'Till Customer'],
        ];

        return (
            <FormSection title="Sync Options" className="settings-page__upload-section">
                <div className="settings-page__upload-check-grid">
                    {checkboxes.map(([name, label]) => this.renderUploadCheckbox(name, label))}
                </div>
                <div className="settings-page__actions settings-page__upload-actions">
                    {this.state.dataSaveButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({dataSaveButtonRender: true, dataResetButtonRender: false});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}
                    {this.state.dataSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--save" onClick={() => {
                            this.showApproveConfirmDialog("Are you sure to sync data?");
                        }}>
                            <Translate contentKey="entity.action.add">Data Sync</Translate>
                        </Button>}
                    {this.state.dataSaveButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.dataUploadTemp;
                            this.setState({
                                dataUpload: Object.assign({}, obj1),
                                dataSaveButtonRender: false,
                                merchantAccountId: null,
                                dataResetButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    }

    dataReset() {
        return (
            <FormSection title="Data Reset" className="settings-page__upload-section">
                <div className="settings-page__upload-check-grid">
                    <div className="settings-page__upload-check-item">
                        <Checkbox
                            onChange={(e) => this.setChecked("definitions", e.checked)}
                            name="definitions"
                            disabled={!this.state.dataResetButtonRender}
                            value={this.state.dataUpload.definitions}
                            checked={this.state.dataUpload.definitions}/>
                        <Label for="definitions">
                            <Translate contentKey="Thursday">Definitions</Translate>
                        </Label>
                    </div>
                    <div className="settings-page__upload-check-item">
                        <Checkbox
                            onChange={(e) => this.setChecked("transactions", e.checked)}
                            name="transactions"
                            disabled={!this.state.dataResetButtonRender}
                            value={this.state.dataUpload.transactions}
                            checked={this.state.dataUpload.transactions}/>
                        <Label for="transactions">
                            <Translate contentKey="Thursday">Transactions</Translate>
                        </Label>
                    </div>
                </div>
                <div className="settings-page__actions settings-page__upload-actions">
                    {this.state.dataResetButtonRender == false &&
                        <Button color="outline-primary" className="settings-page__btn--edit" onClick={() => {
                            this.setState({dataSaveButtonRender: false, dataResetButtonRender: true});
                        }}>
                            <Translate contentKey="entity.action.add">Edit</Translate>
                        </Button>}
                    {this.state.dataResetButtonRender &&
                        <Button color="outline-danger" className="settings-page__btn--delete" onClick={() => {
                            this.showResetConfirmDialog("Are you sure to reset data?");
                        }}>
                            <Translate contentKey="entity.action.add">Data Reset</Translate>
                        </Button>}
                    {this.state.dataResetButtonRender &&
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={() => {
                            let obj1 = this.state.dataUploadTemp;
                            this.setState({
                                dataUpload: Object.assign({}, obj1),
                                dataSaveButtonRender: false,
                                merchantAccountId: null,
                                dataResetButtonRender: false
                            });
                        }}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>}
                </div>
            </FormSection>
        );
    };


    showApproveConfirmDialog = (message) => {
        if (GeneralUtils.isNullOrEmpty(this.state.dataUpload.merchantBranchId)

        ) {
            return toast.warn("Please fill the required fields!");
        } else {
            this.setState({
                displayApproveConfirmDialog: true,
                noticeResponse: message
            });
        }

    }

    showResetConfirmDialog = (message) => {
        if (GeneralUtils.isNullOrEmpty(this.state.dataUpload.merchantBranchId)

        ) {
            return toast.warn("Please fill the required fields!");
        } else {
            this.setState({
                displayResetConfirmDialog: true,
                noticeResponse: message
            });
        }

    }

    saveData = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.dataUpload.merchantBranchId)
        ) {
            return toast.warn("Please fill the required fields!");
        } else {
            this.setState({loading: true});
            this.merchantBranchDataService.upload(this.state.dataUpload)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            dataSaveButtonRender: false, dataUpload: Object.assign({}, defaultUploadData),
                            dataResetButtonRender: false,
                            dataUploadTemp: Object.assign({}, defaultUploadData),
                            merchantAccountId: null

                        });
                        this.setState({loading: false});
                    }
                });
        }

    }

    resetData = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.dataUpload.merchantBranchId)
        ) {
            return toast.warn("Please fill the required fields!");
        } else if (this.state.dataUpload.transactions == false && this.state.dataUpload.definitions == true) {
            return toast.warn("You can't reset only definitions ");
        } else {
            this.setState({loading: true});
            this.merchantBranchDataService.reset(this.state.dataUpload)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            dataSaveButtonRender: false,
                            dataResetButtonRender: false,
                            dataUpload: Object.assign({}, defaultUploadData),
                            dataUploadTemp: Object.assign({}, defaultUploadData),
                            merchantAccountId: null
                        });
                        this.setState({loading: false});
                    }
                });
        }

    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let dataUpload = this.state.dataUpload;
        dataUpload[e.target.name] = value;
        this.setState({dataUpload: dataUpload});
    }

    __handleChangeMerchantAccount = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;

        if (!GeneralUtils.isNullOrEmpty(value)) {
            this.merchantBranchService.findBranchesByAccountIdForCombo(value).then(response => this.setState({
                merchantBranchList: response
            }));
        } else {
            this.setState({merchantBranchList: []});
        }

        this.setState({merchantAccountId: value});

    }

    setChecked = (name, value) => {
        let dataUpload = this.state.dataUpload;
        dataUpload[name] = value;
        this.setState({dataUpload: dataUpload});
    }

}

